export default "__VITE_ASSET__CLwlYDOh__"